import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=00b9ddb6&scoped=true&"
import script from "./materialList.vue?vue&type=script&lang=js&"
export * from "./materialList.vue?vue&type=script&lang=js&"
import style0 from "./materialList.vue?vue&type=style&index=0&id=00b9ddb6&prod&lang=less&scoped=true&"
import style1 from "./materialList.vue?vue&type=style&index=1&id=00b9ddb6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b9ddb6",
  null
  
)

export default component.exports